<template>
    <el-table ref="tab" v-if="tableData.length > 0 && updatePoints" height="100%" :data="tableData" style="width: 100%">
        <el-table-column fixed prop="loopName" label="回路名称" width="220">
        </el-table-column>

        <el-table-column fixed prop="date" label="日期" width="160">
        </el-table-column>

        <el-table-column :key="index" v-show="item.node" v-for="(item, index) in nodeDetails" width="440"
            :label="item.label">
            <el-table-column width="177" label="最大值">
                <el-table-column :prop="`${item.node}_max`" label="数值" width="88">
                </el-table-column>
                <el-table-column :prop="`${item.node}_max_time`" label="发生时间" width="120">
                </el-table-column>
            </el-table-column>
            <el-table-column width="177" label="最小值">
                <el-table-column :prop="`${item.node}_min`" label="数值" width="88">
                </el-table-column>
                <el-table-column :prop="`${item.node}_min_time`" label="发生时间" width="120">
                </el-table-column>
            </el-table-column>
            <el-table-column :prop="`${item.node}_mean`" width="88" label="平均值">
            </el-table-column>
        </el-table-column>
    </el-table>
    <div v-else class="row-center tip">
        <img v-if="!loading" src="../../../assets/img/not_found_data.png" alt="">
        <img v-else src="../../../assets/img/loading.png" alt="" class="loading">
    </div>
</template>

<script>
    import {
        EXTREMUM_VALUES
    } from "../../../api/power"
    import {
        floatFormat
    } from "../../../util/MathUtil"
    import {
        dateFormat,
        dayEnd,
        dayStart,
        monthEnd,
        monthStart
    } from "../../../util/DateUtil"
    import exportExcel from "../../../util/excel";
    import ExcelJS from 'exceljs'
	import FileSaver from 'file-saver'
    const UNIT = {
		"PF": "",
		"PFa": "",
		"PFb": "",
		"PFc": "",
		"PA": " kW",
		"PAa": " kW",
		"PAb": " kW",
		"PAc": " kW",
		"PR": " kVar",
		"PRa": " kVar",
		"PRb": " kVar",
		"PRc": " kVar",
		"P": " kVA",
		"Pa": " kVA",
		"Pb": " kVA",
		"Pc": " kVA",
		"F": " Hz",
		"Ua": " V",
		"Ub": " V",
		"Uc": " V",
		"Uab": " V",
		"Ubc": " V",
		"Uac": " V",
		"Ia": " A",
		"Ib": " A",
		"Ic": " A",
	}
    export default {
        name: "Extremum",
        props: {
            loops: Array,
            nodes: Array,
            range: String,
            date: Date,
            nodeDetails: Array
        },
        data() {
            return {
                loading: false,
                requestRes: [],
                timeDate:false
            }
        },
        computed: {
            diagramStatus() {
                return this.$store.state.project.diagramStatus
            },
            tableData() {
                if (this.requestRes.length === 0) {
                    return []
                }
                let date = this.range === 'day' ? this.date.toLocaleDateString() : this.date.getFullYear() + '/' + (this
                    .date.getMonth() + 1)
                return this.loops.map(l => {
                    let obj = {
                        loopName: l.loopName,
                        date
                    }

                    this.nodes.forEach(n => {
                        this.requestRes.forEach((res, index) => {
                            try {
                                let extremum = res.data.data.extremum;

                                for (let k in extremum) {
                                    if (extremum.hasOwnProperty(k)) {
                                        var start = k.indexOf("/");
                                        var s = k.substring(start + 1);
                                        extremum[s] = extremum[k]
                                    }
                                }
                                let num = 1
                                if(UNIT[n].indexOf('k')!=-1){
                                    num = 1000
                                }
                                if (index === 0) {
                                    obj[`${n}_max`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?floatFormat(Number(extremum[
                                        `${l.subLoopUrl}_${n}`].max)/num, 2)+`${UNIT[n]}`:'--'
                                    obj[`${n}_max_time`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time):'--'
                                }
                                if (index === 1) {
                                    obj[`${n}_min`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?floatFormat(Number(extremum[
                                        `${l.subLoopUrl}_${n}`].min/num), 2)+`${UNIT[n]}`:'--'
                                    obj[`${n}_min_time`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time):'--'
                                }
                                if (index === 2) {
                                    obj[`${n}_mean`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?floatFormat(Number(extremum[
                                        `${l.subLoopUrl}_${n}`].mean/num), 2)+`${UNIT[n]}`:'--'
                                }
                                // console.log(obj,"obj")
                            } catch (e) {

                            }
                        })

                    })
                    // console.log(obj,"obj")
                    return obj
                }) || []
            },
            ids() {
                return this.loops.map(l => l.loopId)
            },
            updatePoints() {
                return [this.loops, this.nodes, this.range, this.date, this.nodeDetails]
            },
            
			dateName(){
				switch (this.range) {
					case 'day':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
					case 'week':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "周"
						break;
					case 'month':
						this.timeDate = dateFormat("YY-mm", this.date)
						return "月"
						break;
					case 'year':
						this.timeDate = dateFormat("YY", this.date)
						return "年"
						break;
					default:
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
				}
			},
			selProjectName() {
				return this.$store.getters.selProjectInfo.projectName;
			},
        },
        watch: {
            diagramStatus(n) {
                if (this.$route.query.uid=== 'Extremum' ) {
                    if (n.type === 'excel' && this.tableData.length > 0) {

                        let data = [
                            ['回路名称', '日期'],
                            [null, null],
                            [null, null],
                        ]

                        let map = ['loopName', 'date']

                        let merges = [{
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 2,
                                    c: 0
                                }
                            },
                            {
                                s: {
                                    r: 0,
                                    c: 1
                                },
                                e: {
                                    r: 2,
                                    c: 1
                                }
                            },
                        ]

                        // 动态添加后面的
                        this.nodeDetails.forEach((nodeInfo, index) => {
                            data[0].push(nodeInfo.label)
                            data[0].push(null)
                            data[0].push(null)
                            data[0].push(null)
                            data[0].push(null)
                            data[1].push('最大值')
                            data[1].push(null)
                            data[1].push('最小值')
                            data[1].push(null)
                            data[1].push('平均值')

                            data[2].push('数值')
                            data[2].push('发生时间')
                            data[2].push('数值')
                            data[2].push('发生时间')
                            data[2].push(null)
                            // 数据映射
                            map.push(nodeInfo.node + "_max")
                            map.push(nodeInfo.node + "_max_time")
                            map.push(nodeInfo.node + "_min")
                            map.push(nodeInfo.node + "_min_time")
                            map.push(nodeInfo.node + "_mean")

                            // 合并单元格
                            merges.push({
                                s: {
                                    r: 0,
                                    c: 2 + 5 * index
                                },
                                e: {
                                    r: 0,
                                    c: 6 + 5 * index
                                }
                            })
                            merges.push({
                                s: {
                                    r: 1,
                                    c: 2 + 5 * index
                                },
                                e: {
                                    r: 1,
                                    c: 3 + 5 * index
                                }
                            })
                            merges.push({
                                s: {
                                    r: 1,
                                    c: 4 + 5 * index
                                },
                                e: {
                                    r: 1,
                                    c: 5 + 5 * index
                                }
                            })
                            merges.push({
                                s: {
                                    r: 1,
                                    c: 6 + 5 * index
                                },
                                e: {
                                    r: 2,
                                    c: 6 + 5 * index
                                }
                            })


                        })
                        // 数据
                        this.tableData.forEach(d => {
                            data.push(map.map(k => d[k]))
                        })
                        exportExcel(data, '电力极值报表', merges)
                        return
                        const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
                        let arr = ['A','B','C','D','E']
                            arr.forEach(elm=>{
                                letter.forEach(item=>{
                                    letter.push(elm+item)
                                })
                            })
							letter = letter.filter((e,i)=>i<this.nodeDetails.length*5+2)
						let sheetName = ["电力极值"+this.dateName+"报表",this.selProjectName,'日期：'+this.timeDate]
							let style =  {
								fill: {
									type: 'gradient',
									gradient: 'angle',
									degree: 0,
									stops: [
									{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
									{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
									{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
									]
								},
								font20:{
									name: 'Arial',
									size: 20,
									bold: true
								},
								font12bold:{
									name: 'Arial',
									size: 12,
									bold: true
								},
								font12:{
									name: 'Arial',
									size: 12,
									// bold: true
								},
								alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
								alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
								border:{
									top: {style:'thin'},
									left: {style:'thin'},
									bottom: {style:'thin'},
									right: {style:'thin'}
								}
							}

							//处理一二层
				
							sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
							sheet.getCell(letter[0]+'1').value = sheetName[0]
							sheet.getCell(letter[0]+'1').font = style.font20
							sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
							
							sheet.mergeCells('A2:B2');
							sheet.mergeCells('C2:'+letter[letter.length-1]+'2');
							sheet.getCell('A2').value = sheetName[1]
							sheet.getCell('C2').value = sheetName[2]
							sheet.getRow(2).font = style.font12bold
							sheet.getRow(2).alignment = style.alignmentLeft
							const rows = sheet.getRows(1, 2);
							rows.map(e=>{e.height = 50 ;return e})

							//表格设置
							sheet.addRow(data[0]);
                            sheet.addRow(data[1]);
                            sheet.addRow(data[2]);

                            let len = this.nodeDetails.length
                            this.tableData.forEach((d, i) => {
								if(i % 5 === 0){
									sheet.mergeCells('C'+(2 + i)+':'+letter[i]+(5+i+2));
								}
							})

                            // sheet.mergeCells('A3:A4');
                            // sheet.mergeCells('B3:C3');
                            // sheet.mergeCells('D3:E3');
                            // sheet.mergeCells('F3:G3');
                            // sheet.mergeCells('H3:I3');
                            // sheet.getCell('B3').value = '电';
                            // sheet.getCell('D3').value = '水';
                            // sheet.getCell('F3').value = '热';
                            // sheet.getCell('H3').value = '冷';
							//表格头部样式
                            let num = [3,4,5]
                            letter.forEach(item=>{
                                num.forEach(elm=>{
                                    sheet.getRow(elm).height = 59
                                    sheet.getRow(elm).font=style.font12bold
                                    sheet.getRow(elm).alignment = style.alignmentCenter
                                    sheet.getCell(item+elm).fill = style.fill;
                                    sheet.getCell(item+elm).border = style.border
                                })
                            })
							data.slice(3).forEach((item,index)=>{
                                sheet.addRow(item);
								sheet.getRow(6+index).height = 38
								sheet.getRow(6+index).font=style.font12
								letter.forEach((e,i)=>{
									if(i<=1){
										sheet.getColumn(e).width = 26
									}else{
										sheet.getColumn(e).width = 14
									}
									sheet.getCell(e+(6+index)).border = style.border
								})
								sheet.getRow(6+index).alignment = style.alignmentCenter
							})

						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
						})
                    } else {
                        this.$message.warning("无图表数据！")
                    }
                }
            },
            updatePoints(n) {
                this.requestValues()
            },
            loops(n,o){
                if (this.requestRes.length === 0) {
                    return []
                }
                let date = this.range === 'day' ? this.date.toLocaleDateString() : this.date.getFullYear() + '/' + (this
                    .date.getMonth() + 1)
                return this.loops.map(l => {
                    let obj = {
                        loopName: l.loopName,
                        date
                    }

                    this.nodes.forEach(n => {
                        this.requestRes.forEach((res, index) => {
                            try {
                                let extremum = res.data.data.extremum;

                                for (let k in extremum) {
                                    if (extremum.hasOwnProperty(k)) {
                                        var start = k.indexOf("/");
                                        var s = k.substring(start + 1);
                                        extremum[s] = extremum[k]
                                    }
                                }
                                if (index === 0) {
                                    obj[`${n}_max`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].max, 2):'--'
                                    obj[`${n}_max_time`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time):'--'
                                }
                                if (index === 1) {
                                    obj[`${n}_min`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].min, 2):'--'
                                    obj[`${n}_min_time`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time):'--'
                                }
                                if (index === 2) {
                                    obj[`${n}_mean`] = extremum[
                                        `${l.subLoopUrl}_${n}`]?floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].mean, 2):'--'
                                }
                            } catch (e) {

                            }
                        })

                    })
                    console.log(obj,"obj")
                    return obj
                }) || []
            }
        },
        methods: {
            timeGenerate(time) {
                let date = new Date(time);
                if (this.range === 'day') {
                    return dateFormat("HH:MM:SS", date)
                } else {
                    return dateFormat("d日 HH:MM:SS", date)
                }
            },
            async requestValues() {

                this.requestRes = []
                if (this.loops.length === 0 || this.nodes.length === 0) {
                    return
                }
                this.loading = true

                let start
                let end
                if (this.range === 'day') {
                    start = dayStart(this.date)
                    end = dayEnd(this.date)
                } else {
                    start = monthStart(this.date)
                    end = monthEnd(this.date)
                }
                let res = []
                try {
                    res = await Promise.all([
                        EXTREMUM_VALUES(this.ids, this.nodes, "MAX", start, end),
                        EXTREMUM_VALUES(this.ids, this.nodes, "MIN", start, end),
                        EXTREMUM_VALUES(this.ids, this.nodes, "MEAN", start, end),
                    ])
                } catch (e) {

                } finally {
                    console.log(res)
                    this.requestRes = res
                    this.loading = false
                }


            }
        },
        mounted() {
            this.requestValues()
        },


    }
</script>

<style scoped lang="less">
    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>